import { isString, isFunction, get, isEmpty } from 'lodash';
import { put, fork, takeEvery, all } from 'redux-saga/effects';

import { showNotification, showDialogNotification } from 'modules/snackbar';
import * as applicationsModule from 'modules/application';
import * as enginesModule from 'modules/engine';
import * as buildsModule from 'modules/engine-builds';
import * as tasksModule from 'modules/engine-tasks';
import * as dataSchemasModule from 'modules/data-schema';

// ***
// Notifications for actions
// ***

const snackbarMessages = {
  [applicationsModule.APPLICATION_ACTION_SUCCESS]: {
    message: action => `Application ${action.meta.input.action} was successful.`
  },
  [applicationsModule.APPLICATION_ACTION_FAILURE]: {
    message: action =>
      `Application ${action.meta.input.action} failed. Please try again.`
  },
  [applicationsModule.CREATE_FAILURE]: {
    message: handleEntityFailureNotificationMsg
  },
  [applicationsModule.UPDATE_FAILURE]: {
    message: handleEntityFailureNotificationMsg
  },
  [applicationsModule.DELETE_SUCCESS]: {
    message: 'Application deleted successfully.'
  },
  [applicationsModule.DELETE_FAILURE]: {
    message: 'Application failed to delete. Please try again.'
  },
  [enginesModule.ENGINE_ACTION_SUCCESS]: {
    message: action => {
      const errors = get(action, 'payload.errors');

      if (!isEmpty(errors)) {
        return `Engine ${action.meta.action} failed. Please try again.`;
      }

      return `Engine ${action.meta.action} was successful.`;
    }
  },
  [enginesModule.ENGINE_ACTION_FAILURE]: {
    message: action => `Engine ${action.meta.action} failed. Please try again.`
  },

  [enginesModule.DELETE_SUCCESS]: {
    message: action => {
      const errors = get(action, 'payload.errors');

      if (!isEmpty(errors)) {
        return 'Engine failed to delete. Please try again.';
      }

      return 'Engine deleted successfully.';
    }
  },
  [enginesModule.DELETE_FAILURE]: {
    message: 'Engine failed to delete. Please try again.'
  },

  [buildsModule.BUILD_ACTION_SUCCESS]: {
    message: action => {
      if (action.meta.input.action === 'deploy') {
        return 'Starting deployment.';
      }

      return `Build ${action.meta.input.action} was successful.`;
    }
  },
  [buildsModule.BUILD_ACTION_FAILURE]: {
    message: action =>
      `Build ${action.meta.input.action} failed. Please try again.`
  },
  [tasksModule.CREATE_SANDBOX_TASK_FAILURE]: {
    message: 'Failed to create task. Please try again.'
  },
  [buildsModule.DELETE_SUCCESS]: { message: 'Build deleted successfully.' },
  [buildsModule.DELETE_FAILURE]: {
    message: 'Build failed to delete. Please try again.'
  },
  [dataSchemasModule.UPDATE_FAILURE]: {
    message: 'Action failed. Something went wrong; please try again later.'
  },
  [dataSchemasModule.UPDATE_SCHEMA_SUCCESS]: {
    message: action => {
      const errors = get(action, 'payload.errors');

      if (!isEmpty(errors)) {
        return errors[0].message;
      }
    }
  },
  [dataSchemasModule.LIST_RELATED_DATA_SCHEMAS_FAILURE]: {
    message: 'Action failed. Something went wrong; please try again later.'
  },
  [dataSchemasModule.LIST_RELATED_DATA_SCHEMAS_SUCCESS]: {
    message: action => {
      const errors = get(action, 'payload.errors');

      if (!isEmpty(errors)) {
        return errors[0].message;
      }
    }
  }
};

const dialogMessages = {
  [buildsModule.BUILD_ACTION_SUCCESS]: {
    test: action => action.meta.input.action === 'deploy',
    message:
      'The deployment process has been initiated for your engine. ' +
      'Once successfully deployed, open CMS to upload media and run your engine against it.'
  }
};

function* onSnackbarNotificationAction(action) {
  const { message, test } = snackbarMessages[action.type];

  if (isFunction(test) && !test(action)) {
    return;
  }

  yield put(showNotification(isString(message) ? message : message(action)));
}

function* onDialogNotificationAction(action) {
  const { message, test } = dialogMessages[action.type];

  if (isFunction(test) && !test(action)) {
    return;
  }

  yield put(
    // todo: add title
    showDialogNotification(null, isString(message) ? message : message(action))
  );
}

function* watchSnackbarNotificationActions() {
  const notificationTypes = [...Object.keys(snackbarMessages)];

  yield takeEvery(notificationTypes, onSnackbarNotificationAction);
}

function* watchDialogNotificationActions() {
  const notificationTypes = [...Object.keys(dialogMessages)];

  yield takeEvery(notificationTypes, onDialogNotificationAction);
}

function handleEntityFailureNotificationMsg(action) {
  const actionType = action.type.match(/UPDATE/) ? 'Update' : 'Creation';

  if (get(action.payload, '[0].name') === 'invalid_input') {
    return `${actionType} failed. Please go back and fix the marked errors before trying again.`;
  }

  return `${actionType} failed. Something went wrong; please try again later.`;
}

export default function* root() {
  yield all([fork(watchSnackbarNotificationActions)]);
  yield all([fork(watchDialogNotificationActions)]);
}



// WEBPACK FOOTER //
// ./src/client/modules/notifications.js